import { render, staticRenderFns } from "./OfficeLocation.vue?vue&type=template&id=2f8773c4&scoped=true&"
import script from "./OfficeLocation.vue?vue&type=script&lang=js&"
export * from "./OfficeLocation.vue?vue&type=script&lang=js&"
import style0 from "./OfficeLocation.vue?vue&type=style&index=0&id=2f8773c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8773c4",
  null
  
)

export default component.exports